module.exports = __webpack_public_path__ + "img/3.6.a3c5b1dd.png";